'use strict'

module.exports = function objectOrIdToId (objectOrId) {
  return typeof objectOrId === 'object' ? objectOrId._id : objectOrId
}



//////////////////
// WEBPACK FOOTER
// ./~/pouchdb-hoodie-api/lib/utils/to-id.js
// module id = 34
// module chunks = 7